module.exports = __webpack_public_path__ + "static/media/newContactIcon-2x.209b7bac.png";